import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

interface SideDrawerProps {
    open: boolean;
    onClose: () => void;
    anchor?: 'left' | 'right';
    children: React.ReactNode;
}

export const SideDrawer: React.FC<SideDrawerProps> = ({ open, onClose, anchor, children }) => {
    return (
        <SwipeableDrawer
            anchor={anchor}
            open={open}
            onClose={onClose}
            onOpen={() => {}}
            disableBackdropTransition={false}
            disableDiscovery={false}
            ModalProps={{
                sx: {
                    zIndex: 1400,
                },
            }}
        >
            <Box
                sx={{ width: '80vw', paddingTop: '10px', paddingBottom: '10px', paddingRight: '14px', paddingLeft: '14px' }}
                role="presentation"
                onClick={onClose}
                onKeyDown={onClose}
            >
                {children}
            </Box>
        </SwipeableDrawer>
    );
};
